import * as LS from 'local-storage'

// Auth helpers for artist portal

export function isAuthenticated() {
  return !!LS.getArtistAuthToken()
}

export function isAdmin() {
  return !!LS.getIsAdmin()
}
